module.exports = __webpack_public_path__ + "img/3diamond-10.9758667d.svg";